import * as React from 'react';
import { ContentView } from '@levelapp/softfabric';
import UlListViewStyle from './UlListViewStyle';
import UlListViewModel from './UlListViewModel';
import { View, Text } from 'react-native';
export default class UlListView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new UlListViewModel(this), new UlListViewStyle(this));
    }
    /* RENDERING */
    render() {
        return (React.createElement(View, { style: this.style.container },
            React.createElement(View, { style: this.style.description },
                React.createElement(Text, { style: this.style.descriptionText }, this.props.descriptionBeforeList)),
            React.createElement(View, { style: this.style.containerUL }, this.props.description.map((value, i) => {
                return (React.createElement(View, { key: i, style: this.style.line },
                    React.createElement(Text, { style: this.style.bullet }, this.props.bullets == undefined ? '\u2022' : this.props.bullets),
                    React.createElement(Text, { style: this.style.header },
                        console.log(this.props.title),
                        this.props.title != undefined && this.props.title[i] != undefined ? this.props.title[i] : "[ERROR NO TITLE]"),
                    React.createElement(Text, { style: this.style.text }, this.props.description[i])));
            }))));
    }
    ;
}
